export default __webpack_public_path__ + "static/media/photo.b1877094.jpeg";